module.exports = __webpack_public_path__ + "static/media/brain.e38ecef7.svg";